'use client';

import Script from 'next/script';

export default function GoogleTagManager() {
  return (
    <>
      {/* GTM Head script */}
      {/* lazyOnload defers GTM until requestIdleCallback so it never competes
          with critical resources during initial render. ~280KB of GTM+GA4
          bytes were dominating mobile JS budget; PostHog handles primary
          analytics so GTM loading later is acceptable. */}
      <Script id="gtm-script" strategy="lazyOnload">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MPD7TPQQ');
        `}
      </Script>
    </>
  );
}